import { render } from "./HomeDashboardItem.vue?vue&type=template&id=54ea2066"
import script from "./HomeDashboardItem.vue?vue&type=script&lang=js"
export * from "./HomeDashboardItem.vue?vue&type=script&lang=js"

import "./HomeDashboardItem.vue?vue&type=style&index=0&id=54ea2066&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__